import { useGetDMaxCommon, type Aside1DmaxInfoResponse, type RoomDMaxInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { Aside1Section, RoomDetail, RoomFeed, TopSection } from "../common";
import { OtherRoomPreView } from "../common/components/otherRoomPreview";

export const Rooms = () => {
    const { roomIdx } = useParams<string>();

    const { data: roomData } = useGetDMaxCommon<RoomDMaxInfoResponse>({ section: "room" });
    const { data: aside1Data } = useGetDMaxCommon<Aside1DmaxInfoResponse>({ section: "aside1" });

    const targetRoom = roomData?.rooms.find((t) => t.room_idx === roomIdx);
    const sector = {
        main: {
            firstLine: targetRoom?.room_name || "",
            secondLine: targetRoom?.room_intro || "",
        },
        sub: {
            firstLine: "",
            secondLine: "",
        },
    };

    const ohterRoomList = roomData?.rooms.filter((t) => t.room_idx !== roomIdx);

    return targetRoom && ohterRoomList && aside1Data ? (
        <>
            <TopSection imgList={targetRoom.imgList} sector={sector} color="#fff" />
            <RoomDetail room={targetRoom} />
            <RoomFeed imgList={targetRoom.imgList} />
            <OtherRoomPreView rooms={ohterRoomList} />
            <Aside1Section data={aside1Data} />
        </>
    ) : (
        <Center w="100" h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
